import React from "react";

const Base64ToImage = ({ base64String, urlOnly = true }) => {
  // Create a data URL
  const dataUrl = `data:image/png;base64,${base64String}`;
  if (urlOnly) {
    return dataUrl;
  }
  return <img src={dataUrl} alt='Converted Image' />;
};

export default Base64ToImage;
